import React from 'react';

export function withScrollListener(WrappedComponent) {
    return class extends React.Component {
        state = { x: 0, y: 0 };

        componentDidMount() {
            window.addEventListener('scroll', this._onScroll);
        }
        componentWillUnmount() {
            window.removeEventListener('scroll', this._onScroll);
        }
        _onScroll = scrollPositions => {
            const x = window.pageXOffset;
            const y = window.pageYOffset;
            this.setState({ x: x, y: y });
        };
        render() {
            return <WrappedComponent scroll={this.state} {...this.props} />;
        }
    };
}

export function withScrollDisable(WrappedComponent, timeout = 0) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.scrollState = { x: 0, y: 0 };
        }
        _disableScroll = () => {
            document.body.classList.remove('is-not-scrollable');
            document.body.style.marginTop = '';
            document.body.style.marginLeft = '';
            window.scroll(this.scrollState.x, this.scrollState.y);
        };
        componentWillUnmount() {
            this._disableScroll();
        }
        componentDidUpdate(prevProps) {
            if (prevProps.open === false && this.props.open) {
                const x = window.pageXOffset;
                const y = window.pageYOffset;
                this.scrollState = { x, y };
                setTimeout(() => {
                    document.body.classList.add('is-not-scrollable');
                    document.body.style.marginTop = `-${this.scrollState.y}px`;
                    document.body.style.marginLeft = `-${this.scrollState.x}px`;
                }, timeout);
            }
            if (prevProps.open && this.props.open === false) {
                this._disableScroll();
            }
        }
        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/hocs/scroll.js